import React from 'react';
import { useIntl } from 'react-intl';
import { cn } from 'utils/classNamesTailwind';
import { useId } from 'react';
import { trackMatomoEvent } from 'services/matomo.service';
import { Tile } from '../PageContainer';
import { Button } from 'components/Button';
import { TbIcon, TbIconProps } from 'components/Figma';

export interface I18nMessage {
  id: string;
  values?: Record<string, React.ReactNode>;
}

interface PageRefTileProps {
  iconName?: TbIconProps['name'];
  title: I18nMessage;
  description: I18nMessage;
  onClick?: () => void;
  buttonText: I18nMessage;
  className?: string;
  iconClassName?: string;
  testId?: string;
}

export function PageRefTile({
  iconName = undefined,
  iconClassName = undefined,
  title,
  description,
  onClick = undefined,
  buttonText,
  className = '',
  testId = '',
}: PageRefTileProps) {
  const intl = useIntl();
  const instanceId = useId();

  const handleTileClick = () => {
    trackMatomoEvent({
      action: 'ExploreMoreCard',
      name: {
        defaultNamePrefix: 'page-ref',
        details: [title.id],
        testid: testId,
        instanceId,
      },
      includePageContextInAction: true,
    });
    onClick?.();
  };

  return (
    <Tile
      onClick={handleTileClick}
      className={cn('group/page-ref flex flex-col justify-between gap-2', className)}
      testId={testId}
    >
      <div className="flex flex-col gap-2">
        {iconName && <TbIcon className={cn('text-xl', iconClassName)} name={iconName} />}

        <h3 className="text-sm font-bold text-text-primary">{intl.formatMessage({ id: title.id }, title.values)}</h3>
        <p className="text-sm text-gray-600">{intl.formatMessage({ id: description.id }, description.values)}</p>
      </div>
      <Button
        size="sm"
        priority="ternery"
        iconRight="ArrowRight"
        className="group-hover/page-ref:text-snow-50 group-hover/page-ref:bg-ash-900 group-hover/page-ref:border-ash-900"
      >
        {intl.formatMessage({ id: buttonText.id }, buttonText.values)}
      </Button>
    </Tile>
  );
}
